export function isSuccessfulResponse(status: number) {
  return status >= 200 && status < 300;
}

export function isSuccessfulOrCustomResponse(status: number, allowedStatus: number[]) {
  return isSuccessfulResponse(status) || allowedStatus.includes(status);
}
